export const msalConfig = {
	auth: {
		tenantId: "aeaacdc5-f804-44ff-ab19-29ec1b499f17", 
		clientId: "72734c91-b064-4a1f-88a5-7d4233e4540e", 
		authority: "https://login.microsoftonline.com/common", // use '/common' for multi-tenant login
		redirectUri: "/", 
	},
};